export const PROFILE_DATA_ID = 'profileData-id';
export const PROFILE_DATA_NAME = 'profileData-name';
export const PROFILE_DATA_LOCALE = 'profileData-locale';
export const PROFILE_DEFAULT_CURRENCY = 'profileDataDefaultCurrency';
export const LAST_SELECTED_MOBILE_PHONE_PREFIX = 'lastSelectedMobilePhonePrefix';
export const LAST_SELECTED_PHONE_PREFIX = 'lastSelectedPhonePrefix';
export const LAST_SELECTED_ADDITIONAL_MOBILE_PHONE_PREFIX = 'lastSelectedAdditionalMobilePhonePrefix';
export const LAST_SELECTED_LANGUAGE_CODE = 'lastSelectedLanguageCode';
export const LAST_SELECTED_COUNTRY_CODE = 'lastSelectedCountryCode';
export const LAST_SAVED_COUNTRY_CODE = 'lastSavedCountryCode';
export const LAST_SELECTED_STUDIO_ID = 'lastSelectedStudioId';
export const IS_DUPLICATED_LEAD = 'isDuplicateLead';
export const APPOINTMENT_CREATION_ERROR = 'appointmentCreationError';
export const CONTACTS_HAS_READ_RIGHTS = 'Contacts.Read';
export const CONTACTS_HAS_ADMIN_RIGHTS = 'Contacts.Admin';
